import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchInvoicingDashboardPageData = createAsyncThunk(
  'invoicingDashboard/fetchPageData',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/invoicing/pageData`, { signal });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('invoicingDashboard/fetchPageData failed', e);
      return rejectWithValue(e?.message || 'Failed to load invoicing page data');
    }
  }
);

export const updateInvoicingInformation = createAsyncThunk(
  'invoicingDashboard/updateInformation',
  async ({ actionType, sectionName, updatedValues, rowId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/invoicing/UpdatingInformation`,
        {
          Action: actionType,
          SectionName: sectionName,
          UpdatedValues: updatedValues,
          RowID: rowId,
        },
        {
          signal,
          headers: { 'Content-Type': 'application/json' },
        }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('invoicingDashboard/updateInformation failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to update invoicing information');
    }
  }
);

export const completeInvoiceRequest = createAsyncThunk(
  'invoicingDashboard/completeInvoiceRequest',
  async ({ id }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/invoicing/completeInvoiceRequest`,
        { ID: id },
        { signal, headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('invoicingDashboard/completeInvoiceRequest failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to complete invoice request');
    }
  }
);

const initialState = {
  pageData: null,
  loading: false,
  error: null,
};

const invoicingDashboardSlice = createSlice({
  name: 'invoicingDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoicingDashboardPageData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoicingDashboardPageData.fulfilled, (state, action) => {
        state.loading = false;
        state.pageData = action.payload ?? null;
      })
      .addCase(fetchInvoicingDashboardPageData.rejected, (state, action) => {
        state.loading = false;
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || 'Failed to load invoicing page data';
      })
      .addMatcher(
        (action) => action.type.startsWith('invoicingDashboard/') && action.type.endsWith('/rejected'),
        (state, action) => {
          if (action?.meta?.aborted) return;
          state.error = action.payload || action.error?.message || state.error;
        }
      );
  },
});

export default invoicingDashboardSlice.reducer;


